import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=5df97c6d&scoped=true&"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCard.vue?vue&type=style&index=0&id=5df97c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df97c6d",
  null
  
)

export default component.exports